import React, { useState } from 'react';

const EMPTY = {
  productName: '', category: '', specification: '', HSN: '', GST: '',
  MOQ: '', Unit: '', Price: '', LeadTime: '', Notes: '',
};

const inputCls =
  'w-full bg-white/5 ring-1 ring-white/10 rounded-xl px-3 py-2 text-sm text-white placeholder-white/30 ' +
  'focus:outline-none focus:ring-2 focus:ring-violet-500 transition';
const labelCls = 'flex flex-col gap-1.5 text-[11px] font-semibold uppercase tracking-widest text-white/40';

export default function ProductForm({ initial, onSave, onClose }) {
  const [form, setForm] = useState(initial ? { ...EMPTY, ...initial } : EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.productName.trim()) return;
    setSaving(true);
    try {
      await onSave({ ...form, GST: Number(form.GST) || 0, Price: Number(form.Price) || 0 });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full sm:max-w-xl max-h-[92vh] overflow-y-auto bg-[#14141C] ring-1 ring-white/10
                   rounded-t-3xl sm:rounded-3xl p-6 shadow-2xl shadow-black/50"
      >
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-lg font-bold tracking-tight text-white">{initial ? 'Edit Product' : 'New Product'}</h3>
          <button onClick={onClose} className="text-white/40 hover:text-white text-xl leading-none">✕</button>
        </div>
        <p className="text-xs text-white/40 mb-5">Fields marked * are required.</p>

        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className={`${labelCls} sm:col-span-2`}>
            Product Name *
            <input className={inputCls} value={form.productName} onChange={set('productName')} required />
          </label>
          <label className={labelCls}>Category <input className={inputCls} value={form.category} onChange={set('category')} /></label>
          <label className={labelCls}>HSN <input className={inputCls} value={form.HSN} onChange={set('HSN')} /></label>
          <label className={labelCls}>GST (%) <input type="number" className={inputCls} value={form.GST} onChange={set('GST')} /></label>
          <label className={labelCls}>MOQ <input className={inputCls} value={form.MOQ} onChange={set('MOQ')} placeholder="e.g. 500 units" /></label>
          <label className={labelCls}>Unit <input className={inputCls} value={form.Unit} onChange={set('Unit')} placeholder="e.g. pcs, kg" /></label>
          <label className={labelCls}>Price <input type="number" className={inputCls} value={form.Price} onChange={set('Price')} /></label>
          <label className={labelCls}>Lead Time <input className={inputCls} value={form.LeadTime} onChange={set('LeadTime')} placeholder="e.g. 7–10 days" /></label>
          <label className={`${labelCls} sm:col-span-2`}>Specification <textarea rows={3} className={inputCls} value={form.specification} onChange={set('specification')} /></label>
          <label className={`${labelCls} sm:col-span-2`}>Notes <textarea rows={2} className={inputCls} value={form.Notes} onChange={set('Notes')} /></label>

          <div className="sm:col-span-2 flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} className="px-4 py-2.5 rounded-xl text-sm font-medium bg-white/5 text-white/70 ring-1 ring-white/10 hover:bg-white/10 transition">
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-violet-600 to-fuchsia-500
                         hover:from-violet-500 hover:to-fuchsia-400 shadow-lg shadow-violet-900/30 disabled:opacity-50 transition"
            >
              {saving ? 'Saving…' : 'Save Product'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
